import useAxios from "../services/useAxios";
import {removeCommas} from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import axios from "axios";


export const getBoxByPosition = async (position) => {

    let formData = new FormData();
    formData.append("position", position);
    return await axios
        .post(
            "https://sabadi.ir/api/api/get_banners_info",
            formData
        )
        .then(({data}) => {
            let out = {};

            for (let i of position.split(",")) {
                let items = [];
                let type = "image";
                data.bannerInfo.map(banner => {
                    if (banner.position == i) {
                        type = (banner.type == 0) ? "slider" : "image";
                        items.push({
                            id: banner.banner_management__id,
                            image: banner.path,
                            url: banner.url,
                            sort: +banner.sort,
                            type: banner.type
                        })
                    }
                })

                if (items.length != 0) {
                    items.sort((a, b) => a.sort - b.sort);
                    out = {
                        ...out,
                        [i]: {
                            type,
                            items
                        }
                    }
                }


                // out = {...out, [i]: data.bannerInfo.filter(banner => banner.position == i)}
            }
            return out;
        })
        .catch((err) => {
            console.log(err);
            return undefined;
        });

}